import { db } from "../../firebase";
import { collection, doc, getDocs, query, where } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetActiveAgents = async () => {
  try {
    const clientDocument = await doc(db, "clients", getLocalStorageItem("bid"));

    let agentCollection = collection(clientDocument, "agents");

    const q = query(agentCollection, where("status", "==", "active"));
    const AgentsSnapshot = await getDocs(q);

    let agentData = [];

    AgentsSnapshot.forEach((doc) => {
      agentData.push({ ...doc.data(), id: doc.id });
    });
    return agentData;
  } catch (error) {
    console.log(error);
  }
};

export default GetActiveAgents;
